<template>
  <div class="paySuccess">
    <v-head></v-head>
    <div class="successBox">
      <div class="stepBox">
        <p>
          <img src="@/assets/images/product/stepbg1.png" />
          <span><i class="el-icon-success"></i> 1、填写投保信息 </span>
        </p>
        <p>
          <img src="@/assets/images/product/stepbg2.png" />
          <span><i class="el-icon-success"></i> 2、上传投保资料 </span>
        </p>
        <p :class="isSuccess ? '' : 'activate'">
          <img src="@/assets/images/product/stepbg2.png" v-if="isSuccess" />
          <img src="@/assets/images/product/stepbg2_a.png" v-else />
          <span
            ><i class="el-icon-success" v-if="isSuccess"></i> 3、支付保费
          </span>
        </p>
        <p>
          <img src="@/assets/images/product/stepbg3.png" />
          <span><i class="el-icon-success" v-if="isSuccess"></i> 4、完成 </span>
        </p>
      </div>
      <div>
        <i class="el-icon-success" v-if="isSuccess"></i>
        <i class="el-icon-circle-close" v-else></i>
        <p>{{ toptit }}</p>
        <p>{{ bottomtit }}</p>
        <div class="btnBox">
          <a href="/#/list">跳转产品列表</a>
          <a href="/#/guarantee">跳转保单记录</a>
          <a href="/#/check">跳转批改记录</a>
        </div>
      </div>
    </div>
    <v-foot></v-foot>
  </div>
</template>
<script>
import vHead from "@/components/vhead";
import vFoot from "@/components/vFoot";
export default {
  name: "paySuccess",
  components: {
    vHead,
    vFoot
  },
  data() {
    return {
      isSuccess: true,
      toptit: "恭喜您，订单支付成功！",
      bottomtit: "您的订单已生成，请点击下放按钮转跳页面"
    };
  },
  created() {
    // 获取页面传参
    this.calibrateMode();
  },
  methods: {
    calibrateMode() {
      let _data = this.$route.query;
      if (_data.tradeStatus != "SUCCESS") {
        this.toptit = _data.msg;
        this.bottomtit = "请点击下放按钮转跳页面";
        this.isSuccess = false;
        document.title = this.toptit;
      }
      console.log(_data);
    }
  }
};
</script>
<style lang="scss">
.paySuccess {
  padding-top: 54px;
  .successBox {
    background-image: url("~@/assets/images/product/pay_succeed_bg.png");
    background-size: 100% 100%;
    width: 1200px;
    height: calc(100vh - 304px);
    min-height: 500px;
    margin: 10px auto;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    text-align: center;
    .stepBox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 90px 0 60px;
      p {
        position: relative;
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        width: 270px;
        height: 40px;
        margin: 0;
        span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          i {
            font-size: 20px;
            color: #55d091;
            vertical-align: middle;
          }
        }
      }
      p + p {
        margin-left: -10px;
      }
      p.activate {
        color: rgba(255, 255, 255, 0.85);
      }
    }
    & > .stepBox + div {
      i {
        font-size: 64px;
        font-weight: 400;
        color: #2ca063;
      }
      i.el-icon-circle-close {
        color: #f56c6c;
      }
      i + p {
        font-size: 28px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 40px;
        margin: 25px auto 17px;
        max-width: 80%;
      }
      p + p {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 20px;
        opacity: 0.62;
      }
      p + .btnBox {
        margin: 60px auto 0;
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 457px;
        a {
          background-image: linear-gradient(to right, #fafafa, #f3f3f3);
          border-radius: 16px;
          border: 1px solid #d8d8d8;
          padding: 5px 15px;
          margin: 0 12px;
          transition: all 0.25s;
        }
        a:hover {
          color: #2d8aee;
          border-color: #2d8aee;
        }
      }
    }
  }
}
</style>
